import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useLocation } from 'react-router-dom';

// ✅ Use your v2 checkbox key that includes maulicabs.com in allowed domains
const RECAPTCHA_SITE_KEY = '6LeSNTgrAAAAAFoyCun0p8eYaBqiQ6ZkkBUqSNWh';

const searchEngines = ['google.', 'bing.', 'yahoo.', 'duckduckgo.', 'search.'];

const KeywordProtectedPage = ({ children }) => {
  const location = useLocation();
  const keyword = location.pathname.toLowerCase().replace(/\//g, '');
  const visitKey = `verified-${keyword}`;
  const [verified, setVerified] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);

  useEffect(() => {
    const alreadyVerified = localStorage.getItem(visitKey) === 'true';

    const fromSearchEngine = searchEngines.some(engine =>
      document.referrer.toLowerCase().includes(engine)
    );

    if (alreadyVerified) {
      setVerified(true);
    } else if (fromSearchEngine) {
      setShowCaptcha(true); // only show CAPTCHA if from Google or others
    } else {
      localStorage.setItem(visitKey, 'true'); // mark verified if not from search engine
      setVerified(true);
    }
  }, [visitKey]);

  const handleCaptcha = (token) => {
    if (token) {
      setVerified(true);
      localStorage.setItem(visitKey, 'true');
    }
  };

  if (showCaptcha && !verified) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Please verify you are human to continue</h2>
        <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={handleCaptcha} />
      </div>
    );
  }

  return <>{children}</>;
};

export default KeywordProtectedPage;



// import React, { useEffect, useState } from 'react';
// import ReCAPTCHA from 'react-google-recaptcha';
// import { useLocation } from 'react-router-dom';

// const RECAPTCHA_SITE_KEY = '6LeSNTgrAAAAAFoyCun0p8eYaBqiQ6ZkkBUqSNWh'; // ✅ your real key

// const KeywordProtectedPage = ({ children }) => {
//   const location = useLocation();
//   const keyword = location.pathname.toLowerCase().replace(/\//g, '');
//   const visitKey = `click-count-${keyword}`;
//   const [verified, setVerified] = useState(false);
//   const [showCaptcha, setShowCaptcha] = useState(false);

//   useEffect(() => {
//     const clickCount = parseInt(localStorage.getItem(visitKey)) || 0;

//     if (clickCount >= 2) {
//       setShowCaptcha(true); // On 3rd+ click, show CAPTCHA
//     } else {
//       localStorage.setItem(visitKey, clickCount + 1);
//       setVerified(true);
//     }
//   }, [visitKey]);

//   const handleCaptcha = (token) => {
//     if (token) {
//       setVerified(true);
//       // Reset or increase the count — your choice
//       localStorage.setItem(visitKey, '0'); // Reset count after verification
//     }
//   };

//   if (showCaptcha && !verified) {
//     return (
//       <div style={{ padding: '2rem', textAlign: 'center' }}>
//         <h2>Please verify you are human to continue</h2>
//         <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={handleCaptcha} />
//       </div>
//     );
//   }

//   return <>{children}</>;
// };

// export default KeywordProtectedPage;
